/** @format */

/**
 * Форматирует число для отображения с разделением тысяч
 * @param value - число для форматирования
 * @param decimals - количество знаков после запятой (по умолчанию 0)
 * @returns отформатированная строка
 */
export function formatNumber(value: number, decimals = 0): string {
  if (value == null || isNaN(value) || value === 0) {
    return '0';
  }

  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

